import { Lock } from "lucide-react";

/**
 * Red banner shown to admins/agents whose society is closed
 * (subscription expired or manually closed by DEV).
 * Login is still allowed, but every mutation endpoint returns HTTP 403.
 */
export default function ReadOnlyBanner({ user }) {
  // DEV bypasses the read-only state.
  if (!user || user.role === "dev") return null;
  const soc = user.society;
  if (!soc || soc.status !== "closed") return null;

  const expiresAt = soc.expires_at ? new Date(soc.expires_at) : null;
  const expired = expiresAt && expiresAt < new Date();

  return (
    <div
      className="w-full bg-gradient-to-r from-rose-600 via-red-600 to-rose-600 border-b-2 border-red-800 text-white shadow-md shadow-red-900/20"
      data-testid="readonly-banner"
    >
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-8 py-2.5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <div className="w-8 h-8 rounded-md bg-white/15 ring-1 ring-white/25 flex items-center justify-center shrink-0">
            <Lock className="w-4 h-4 text-white" strokeWidth={2.25} />
          </div>
          <div className="text-xs sm:text-sm font-medium min-w-0 leading-tight">
            <span className="text-[10px] uppercase tracking-[0.18em] font-bold mr-2 px-1.5 py-0.5 rounded bg-white/20" data-testid="readonly-banner-tag">
              {expired ? "Abonnement expiré" : "Société fermée"}
            </span>
            <span className="block sm:inline mt-1 sm:mt-0">
              Toute modification est désactivée (consultation uniquement).{" "}
              <span className="hidden sm:inline">Contactez la direction pour réouvrir la société.</span>
            </span>
          </div>
        </div>
        <div className="text-[11px] sm:text-xs font-semibold bg-white/15 ring-1 ring-white/25 rounded-md px-2.5 py-1 self-end sm:self-auto whitespace-nowrap" data-testid="readonly-banner-society">
          {soc.nom}
        </div>
      </div>
    </div>
  );
}
